import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { bindAudioSettings } from './audio';
import { armMusicAutostart } from './music';
import { getMusicVolume, getSfxVolume, isMuted } from './settings';
import { SFX } from './sfx';
import './styles.css';

bindAudioSettings({ muted: isMuted, sfxVolume: getSfxVolume, musicVolume: getMusicVolume });
armMusicAutostart();
document.addEventListener('pointerdown', () => SFX.unlock(), { once: true });
document.addEventListener(
  'click',
  (e) => {
    if ((e.target as HTMLElement).closest('.btn, .nav button, .hero-card, .col-item, .col-tabs button')) SFX.click();
  },
  true,
);

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
